import React from 'react';
import BaseLayer from './BaseLayer';
import { findDOMNode } from 'react-dom';
import { List, Map } from 'immutable';
import { TILE_VENDORS as TILE } from '../../../consts';

class DGisLayer extends BaseLayer {
  constructor (props) {
    super(props);

    this.clustersInfrastructure = new Map();
    this.getBounds = this.getBounds.bind(this);

    this.tileLayerDGis = null;
    this.tileLayerOSM = null;
  }

  getBounds () {
    const bounds = this.map.getBounds();
    return {
      southwest_lng: bounds.getSouthWest().lng, // юго запад - нижний левый
      southwest_lat: bounds.getSouthWest().lat,
      northeast_lng: bounds.getNorthEast().lng, // севего восток - верхний правый
      northeast_lat: bounds.getNorthEast().lat
    };
  }

  renderSimilar (items) {
    if (!this.map) {
      return;
    }

    const L = window.L;

    const cluster = L.markerClusterGroup({
      spiderfyOnMaxZoom: false,
      zoomToBoundsOnClick: false,
      showCoverageOnHover: false
    });

    cluster.on('clusterclick', (e) => {
      const items = e.layer.getAllChildMarkers()
        .map(item => item.options.data);

      this.openBalloon(e.layer.getLatLng(), items);
    });

    cluster.on('click', (e) => {
      const items = [e.layer.options.data];
      this.openBalloon(e.layer.getLatLng(), items);
    });

    const mainIcon = window.L.divIcon({className: 'maps-placemark', iconAnchor: [10, 10]});
    const markers = items.map(item => {
      return window.L.marker([item.lat, item.lon], {
        icon: mainIcon,
        data: item
      });
    });

    cluster.addLayers(markers);
    this.map.addLayer(cluster);
  }

  openBalloon (coords, items) {
    window.L.popup({
      autoPanPadding: [25, 85],
      closeButton: false
    })
      .setLatLng(coords)
      .setContent(BaseLayer.getRealtyPopup(items))
      .openOn(this.map);
  }

  componentDidMount () {
    const L = window.L;
    const node = findDOMNode(this);
    this.map = L.map(node, {
      zoomControl: false,
      maxZoom: 18,
      minZoom: 9
    });

    this.map.on('load', () => {
      this.handlerOnLoad();
      this.renderMainPlacemark();

      if (!this.props.similar.isEmpty()) {
        this.renderSimilar(this.props.similar.toJS());
      }
      if (this.clustersInfrastructure.isEmpty()) {
        this.willReceiveInfrastructure(this.props.listInfrastructure);
        this.renderInfrastructure(this.props.selectInfrastructureId);
      }
    }).setView([this.lat, this.lon], this.zoom);

    this.map.addControl(new L.Control.Fullscreen({
      position: 'topright',
      title: {
        'false': 'Включить полноэкранный режим',
        'true': 'Выйти из полноэкранного режима'
      }
    }));

    L.control.zoom({
      position: 'topright',
      zoomInTitle: 'Увеличить',
      zoomOutTitle: 'Уменьшить'
    }).addTo(this.map);

    this.tileLayerDGis = L.tileLayer(TILE.dgis.url, {attribution: TILE.dgis.attribution, subdomains: '0123'});
    this.tileLayerDGis.addTo(this.map);

    this.tileLayerOSM = L.tileLayer(TILE.osm.url, {attribution: TILE.osm.attribution});

    this.tileLayerDGis.on('tileerror', () => this.map.addLayer(this.tileLayerOSM));
    this.tileLayerDGis.on('tileload', () => this.map.removeLayer(this.tileLayerOSM));
  }

  renderMainPlacemark () {
    const mainIcon = window.L.divIcon({className: 'maps-placemark maps-main-placemark'});
    const marker = window.L.marker([this.lat, this.lon], {icon: mainIcon});
    this.map.addLayer(marker);
  }

  willReceiveInfrastructure (listInfrastructure) {
    this.clustersInfrastructure = listInfrastructure.map((data, id) => {
      const layerGroup = window.L.layerGroup();

      const mainIcon = window.L.divIcon({className: 'maps-placemark map-icon map-icon-' + id, iconAnchor: [10, 10]});

      data.get('items').map(item => {
        const marker = window.L.marker([item.getIn(['point', 'lat']), item.getIn(['point', 'lon'])], {
          icon: mainIcon
        }).bindPopup(BaseLayer.getInfrastructurePopup(item), {
          autoPanPadding: [25, 85],
          closeButton: false
        });

        layerGroup.addLayer(marker);
      });

      return layerGroup;
    });
  }

  renderInfrastructure (selectInfrastructureId) {
    let categories;

    if (selectInfrastructureId) {
      categories = new List(selectInfrastructureId.split(','));
    } else {
      categories = new List();
    }

    this.clustersInfrastructure.map((cluster, id) => {
      if (categories.includes(id)) {
        this.map.addLayer(cluster);
      } else {
        this.map.removeLayer(cluster);
      }
    });
  }

  componentWillUnmount () {
    this.map.remove();
  }

  render () {
    return (
      <div className='dgis-content' />
    );
  }
}

export default DGisLayer;



// WEBPACK FOOTER //
// ./src/ui/Maps/Layers/DGisLayer.jsx